export default __webpack_public_path__ + "static/media/8cde8397ea9a748e.b73d511f92aaca6da400626a8f90a94c.svg";